import './App.css';
import '../src/moltomedia/style.css';
import './CSS/style.css';
import "./CSS/grid.css";
import "./CSS/mediaQuerries.css";
import GetProduct from './API/ApiCall';
import BiegungCard from './JSX/BiegungCard';
import { useState } from 'react';

function App() {

  const [importLanguage, setLanguage] = useState("DE");
   const getLanguage = (language) =>{
   setLanguage(language)
   }

  return (
    <div className="App">
    
     <div className='container'>
       <div className='row'>
<div className='col-6 posi-col-6'>
  <p>
  <span className='icon-durchbiegung-solid'></span>
  <label>{importLanguage === "DE" ? "Durchbiegung berechnen" : "Calculate deflection"}</label>
  </p>
</div>
<GetProduct  ongetLanguage={getLanguage}/>
           


       </div>
     </div>
    </div>
  );
}

export default App;
